import { createConnection, Connection, DataSource } from "typeorm"
import { go2sim_cached_location_db_connection, go2sim_kami_db_connection, go2sim_router_db_connection, go2sim_shared_db_connection, go2sim_usage_db_connection } from './connections'

let usage_connection:DataSource|void
let shared_connection:DataSource|void
let router_connection:DataSource|void
let tele2_connection:DataSource|void
let location_connection:DataSource|void
let kami_connection:DataSource|void

export async function GetUsageConnection() {
  return new Promise<DataSource>(async (resolve, reject) => {
    if(!usage_connection) {
      usage_connection = await createConnection(go2sim_usage_db_connection).catch(error => console.log("Failed to Connect", error));
      if(usage_connection instanceof DataSource) {
        resolve(usage_connection)
      } else {
        reject()
      }
      return
    } else {
      resolve(usage_connection)
    }  
  })
}

export function CloseUsageConnection() {
  return new Promise<void>(async (resolve, reject) => {
    if(usage_connection) {
      await usage_connection.close()
      usage_connection = undefined
    }
    resolve()
  })
}

export async function GetSharedConnection() {
  return new Promise<DataSource>(async (resolve, reject) => {
    if(!shared_connection) {
      shared_connection = await createConnection(go2sim_shared_db_connection).catch(error => console.log("Failed to Connect", error))
      if(shared_connection instanceof DataSource) {
        resolve(shared_connection)
      } else {
        reject()
      }
      return
    } else {
      resolve(shared_connection)
    }  
  })
}

export function CloseSharedConnection() {
  return new Promise<void>(async (resolve, reject) => {
    if(shared_connection) {
      await shared_connection.close()
      shared_connection = undefined
    }
    resolve()
  })
}

export async function GetRoutersConnection() {
  return new Promise<DataSource>(async (resolve, reject) => {
    if(!router_connection) {
      router_connection = await createConnection(go2sim_router_db_connection).catch(error => console.log("Failed to Connect", error));
      if(router_connection instanceof DataSource) {
        resolve(router_connection)
      } else {
        reject()
      }
      return
    } else {
      resolve(router_connection)
    }  
  })
}

export function CloseRoutersConnection() {
  return new Promise<void>(async (resolve, reject) => {
    if(router_connection) {
      await router_connection.close()
      router_connection = undefined
    }
    resolve()
  })
}

export async function GetLocationConnection() {
  return new Promise<DataSource>(async (resolve, reject) => {
    if(!location_connection) {
      location_connection = await createConnection(go2sim_cached_location_db_connection).catch(error => console.log("Failed to Connect", error));
      if(location_connection instanceof DataSource) {
        resolve(location_connection)
      } else {
        reject()
      }
      return
    } else {
      resolve(location_connection)
    }  
  })
}

export function CloseLocationConnection() {
  return new Promise<void>(async (resolve, reject) => {
    if(location_connection) {
      await location_connection.close()
      location_connection = undefined
    }
    resolve()
  })
}

export async function GetKamiConnection() {
  return new Promise<DataSource>(async (resolve, reject) => {
    if(!kami_connection) {
      kami_connection = await createConnection(go2sim_kami_db_connection).catch(error => console.log("Failed to Connect", error));
      if(kami_connection instanceof DataSource) {
        resolve(kami_connection)
      } else {
        reject()
      }
      return
    } else {
      resolve(kami_connection)
    }  
  })
}

export function CloseKamiConnection() {
  return new Promise<void>(async (resolve, reject) => {
    if(kami_connection) {
      await kami_connection.close()
      kami_connection = undefined
    }
    resolve()
  })
}